import { NavLogo } from '../Navbar/NavbarElements'
import { CgFormatRight } from "react-icons/cg";
import '../Navbar/Navbar.css'

const Index2 = ({ toggle }) => {
  return (
    <div className='Nav'>
        <div className='NavbarContainer'>
            <NavLogo to='/'>
                <div className='Navlogo' />
            </NavLogo>
             <div className='MobileIcon2' onClick={toggle}>
                <CgFormatRight />
            </div>
        </div>
    </div>
  )
}

export default Index2